export default __webpack_public_path__ + "static/media/fr-h.7be6553f.svg";